import { render } from "./Recordings.vue?vue&type=template&id=3f2ed37a&scoped=true"
import script from "./Recordings.vue?vue&type=script&lang=js"
export * from "./Recordings.vue?vue&type=script&lang=js"

import "./Recordings.vue?vue&type=style&index=0&id=3f2ed37a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2ed37a"]])

export default __exports__